<template><div class="app-on-home"><div class="bt-component" v-bind:time="timeupdate"><div class="wapper"><input type='hidden' value=" 6a16d652e81b18848682267f" id="bt-idapp"/>
        <div id="urlQrcode">
          <div class="hidding-pc" style="padding: 8px;">
            <p style="font-weight: 900;">Share app</p>
            <p onclick="urlQrcodeSlideToggle()" style="position: absolute;top: 8px;right: 15px;color: #e8441f;">
              Done
            </p>
          </div>
          <div class="center-div">
            <qrcode class="image-qrcode" v-bind:value="urlQrcode"></qrcode>
            <div class="font-weight-bold">Spinning is a gift</div>
            <div class="title-qrcode text-black-50 hidding-pc">
              Open this app by scanning the qr code with your phone's camera
            </div>
            <button onclick="shareLink()" class="btn btn-outline-danger hidding-pc">Share link</button>
          </div>
        </div>
      <div class="block-widget bt-1614928661519 " ddd="d" bt-type="blockColumnOnly"><div class="block-content"><div class="block-widget bt-1614928709592 " ddd="d" bt-type="blockHtml" @click="click($event, 'dW5kZWZpbmVk')"><div class="block-content"><img width="100%" height="100%" v-bind:src="gm('cauhinhgame','bgvongquay','0') " v-if="gm('cauhinhvongquay','trangthaivq','0') === '0'" src="https://static.botbanhang.vn/appon/cf1662ea-078f-44ce-b1a2-70be6252eef0-1778475262467.png"> 
<div class="vong-quay" v-bind:style="{'width':'600px', 'zoom': '0.5', 'height':'600px','background-image': 'url(' + gm('cauhinhgame','bgvongquay','0') + ')', 'background-size': 'cover'}">
    <canvas id="canvas" width="600" height="600">
                Canvas not supported, use another browser.
            </canvas>
 </div>                                 </div></div><div class="block-widget bt-1614928876606 " ddd="d" bt-type="blockButton" v-on:dblclick="dbclickfn($event)" @click="click($event, 'W3siaWQiOjE2MTUxNzc2NTY0MDAsInR5cGUiOiJmdW5jdGlvbiIsImRhdGEiOiJydW52b25ncXVheSIsInRpbWVfb3V0IjowLCJjb25maWciOnsiMCI6InIiLCIxIjoidSIsIjIiOiJuIiwiMyI6InYiLCI0IjoibyIsIjUiOiJuIiwiNiI6ImciLCI3IjoicSIsIjgiOiJ1IiwiOSI6ImEiLCIxMCI6InkifX1d')"><div class="block-content undefined"></div></div><div class="block-widget bt-1638954191370 " ddd="d" bt-type="blockImage" @click="click($event, 'dW5kZWZpbmVk')"><div class="block-content"><img src="https://static.botbanhang.vn/appon/82934c88-69eb-4df7-b20b-064287ece14a-1778405683681.png"></div></div></div></div><div class="block-widget bt-1615685249442 " ddd="d" bt-type="blockColumnOnly"><div class="block-content"><div class="block-widget bt-1620980294208 " ddd="d" bt-type="blockText" @click="click($event, 'dW5kZWZpbmVk')"><div class="block-content"><p><br></p><ol><li><span style="color: rgb(8, 27, 58);">0% Commission (1Month)</span></li><li><span style="color: rgb(8, 27, 58);">50% Off Commission (1M)</span></li><li><span style="color: rgb(8, 27, 58);">25% Off Commission (1M)</span></li><li><span style="color: rgb(8, 27, 58);">10% Off Commission (1M)</span></li><li><span style="color: rgb(8, 27, 58);">5% Off Commission (1M)</span></li><li><span style="color: rgb(8, 27, 58);">10% OFF Mini Game</span></li><li><span style="color: rgb(8, 27, 58);">5% OFF Mini Game</span></li><li><span style="color: rgb(8, 27, 58);">Bonus Consultation</span></li></ol><p><br></p></div></div></div></div></div></div><div v-if="page == 'thongtinkhachhang'" class='page-popup' data-page='thongtinkhachhang'><thongtinkhachhang v-on:actionPage="actionPage($event)"><thongtinkhachhang/></div><div v-if="page == 'camon'" class='page-popup' data-page='camon'><camon v-on:actionPage="actionPage($event)"><camon/></div><div v-if="page == 'thongbao'" class='page-popup' data-page='thongbao'><thongbao v-on:actionPage="actionPage($event)"><thongbao/></div><div v-if="page == 'phanqua'" class='page-popup' data-page='phanqua'><phanqua v-on:actionPage="actionPage($event)"><phanqua/></div><div v-if="page == 'quaquay'" class='page-popup' data-page='quaquay'><quaquay v-on:actionPage="actionPage($event)"><quaquay/></div><div v-if="page == 'quadanhan'" class='page-popup' data-page='quadanhan'><quadanhan v-on:actionPage="actionPage($event)"><quadanhan/></div><div v-if="page == 'share'" class='page-popup' data-page='share'><share v-on:actionPage="actionPage($event)"><share/></div><div v-if="page == 'themluot'" class='page-popup' data-page='themluot'><themluot v-on:actionPage="actionPage($event)"><themluot/></div><div v-if="page == 'matluot'" class='page-popup' data-page='matluot'><matluot v-on:actionPage="actionPage($event)"><matluot/></div><div v-if="page == 'chiase'" class='page-popup' data-page='chiase'><chiase v-on:actionPage="actionPage($event)"><chiase/></div><div v-if="page == 'loading'" class='page-popup' data-page='loading'><loading v-on:actionPage="actionPage($event)"><loading/></div></div></template><style scoped>body{width:100%;height:100%;overflow: hidden;line-height:1.5;}.app-on-home > .bt-component .wapper:first-child{padding:0!important;} .wapper{-webkit-overflow-scrolling: touch;-webkit-overflow-scrolling-x: touch;background:#FFFFFF;}
      @media screen and (min-width: 320px) and (max-width: 767px){
        body{height:100vh;}

        .bt-1614928661519{ height:773px;width:420px;max-width: 420px!important;position:relative!important;background-image: -webkit-linear-gradient( rgba(0,0,0,0), rgba(0,0,0,0)), url("https://static.botbanhang.vn/appon/e681f4b3-1328-4d85-af73-bc59017df571-1778715325402.png");background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1614928661519 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:773px;overflow: hidden; }.bt-1614928661519 p,.bt-1614928661519 h1,.bt-1614928661519 h2,.bt-1614928661519 h3,.bt-1614928661519 h4,.bt-1614928661519 h5,.bt-1614928661519 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592{ width:300px;left:50px;height:300px;top:172px;transform: translate(9.1px, 86.6px); }.bt-1614928709592 > .block-content{ background-color:transparent;background:transparent;font-family:Cabin;border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 p,.bt-1614928709592 h1,.bt-1614928709592 h2,.bt-1614928709592 h3,.bt-1614928709592 h4,.bt-1614928709592 h5,.bt-1614928709592 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 > .block-content{ 
	overflow: hidden;
}.bt-1614928876606{ width:182px;left:120px;height:46px;top:574px; }.bt-1614928876606 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/aa8552cd-af6f-4ffe-b69c-94a242a1b13a-1778405985177.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Francois One;border-radius:20px 20px 20px 20px;border-width:0px;border-top-width:undefined;border-left-width:undefined;border-right-width:undefined;border-bottom-width:undefined;border-color:#000000;border-style:solid;color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1614928876606 p,.bt-1614928876606 h1,.bt-1614928876606 h2,.bt-1614928876606 h3,.bt-1614928876606 h4,.bt-1614928876606 h5,.bt-1614928876606 h6{ color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1615685249442{ height:774px;width:420px;max-width: 420px!important;position:relative!important;background-image: url('https://static.botbanhang.vn/appon/0c43d484-a6e7-407a-b447-9a2c8cf4f5b6-1778746641055.png');background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1615685249442 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:774px;overflow: hidden; }.bt-1615685249442 p,.bt-1615685249442 h1,.bt-1615685249442 h2,.bt-1615685249442 h3,.bt-1615685249442 h4,.bt-1615685249442 h5,.bt-1615685249442 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1620980294208{ width:250px;left:95px;height:533px;top:198px;transform: translate(-9.7px, -14px); }.bt-1620980294208 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Oswald;text-align:justify;border-radius:0px 0px 0px 0px;color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1620980294208 p,.bt-1620980294208 h1,.bt-1620980294208 h2,.bt-1620980294208 h3,.bt-1620980294208 h4,.bt-1620980294208 h5,.bt-1620980294208 h6{ color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1638954191370{ width:23px;left:195px;height:30px;top:262px;transform: translate(3.8px, 2px); }.bt-1638954191370 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 p,.bt-1638954191370 h1,.bt-1638954191370 h2,.bt-1638954191370 h3,.bt-1638954191370 h4,.bt-1638954191370 h5,.bt-1638954191370 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 > .block-content{ 
	/*
	* This feature only support developer.
	* Use !important for overwrite css.
	* For example:
	* font-size: 15px !important;
	* text-align: center !important;
	* ...
	*/
}
        .desktop-app{
          width:100%!important;
          height: 100%!important;
        }
        .bt-component{
          width: 100%!important;
        }
        .wapper{
          width: 100%!important;
        }
        .block-widget[bt-type="blockColumnOnly"]{
          width: 100%!important;
        }
        .block-widget[bt-type="blockColumnOnly"] > .block-content{
          width: 100%!important;
        }
        .block-widget[bt-type="blockList"]{
          width: 100%!important;
        }
        .block-widget[bt-type="blockList"] > .block-content{
          width: 100%;
        }
      }
      @media screen and (min-width: 768px) and (max-width: 959px){
        .bt-1614928661519{ height:773px;width:420px;max-width: 420px!important;position:relative!important;background-image: -webkit-linear-gradient( rgba(0,0,0,0), rgba(0,0,0,0)), url("https://static.botbanhang.vn/appon/e681f4b3-1328-4d85-af73-bc59017df571-1778715325402.png");background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1614928661519 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:773px;overflow: hidden; }.bt-1614928661519 p,.bt-1614928661519 h1,.bt-1614928661519 h2,.bt-1614928661519 h3,.bt-1614928661519 h4,.bt-1614928661519 h5,.bt-1614928661519 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592{ width:300px;left:50px;height:300px;top:172px;transform: translate(9.1px, 86.6px); }.bt-1614928709592 > .block-content{ background-color:transparent;background:transparent;font-family:Cabin;border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 p,.bt-1614928709592 h1,.bt-1614928709592 h2,.bt-1614928709592 h3,.bt-1614928709592 h4,.bt-1614928709592 h5,.bt-1614928709592 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 > .block-content{ 
	overflow: hidden;
}.bt-1614928876606{ width:182px;left:120px;height:46px;top:574px; }.bt-1614928876606 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/aa8552cd-af6f-4ffe-b69c-94a242a1b13a-1778405985177.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Francois One;border-radius:20px 20px 20px 20px;border-width:0px;border-top-width:undefined;border-left-width:undefined;border-right-width:undefined;border-bottom-width:undefined;border-color:#000000;border-style:solid;color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1614928876606 p,.bt-1614928876606 h1,.bt-1614928876606 h2,.bt-1614928876606 h3,.bt-1614928876606 h4,.bt-1614928876606 h5,.bt-1614928876606 h6{ color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1615685249442{ height:774px;width:420px;max-width: 420px!important;position:relative!important;background-image: url('https://static.botbanhang.vn/appon/0c43d484-a6e7-407a-b447-9a2c8cf4f5b6-1778746641055.png');background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1615685249442 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:774px;overflow: hidden; }.bt-1615685249442 p,.bt-1615685249442 h1,.bt-1615685249442 h2,.bt-1615685249442 h3,.bt-1615685249442 h4,.bt-1615685249442 h5,.bt-1615685249442 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1620980294208{ width:250px;left:95px;height:533px;top:198px;transform: translate(-9.7px, -14px); }.bt-1620980294208 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Oswald;text-align:justify;border-radius:0px 0px 0px 0px;color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1620980294208 p,.bt-1620980294208 h1,.bt-1620980294208 h2,.bt-1620980294208 h3,.bt-1620980294208 h4,.bt-1620980294208 h5,.bt-1620980294208 h6{ color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1638954191370{ width:23px;left:195px;height:30px;top:262px;transform: translate(3.8px, 2px); }.bt-1638954191370 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 p,.bt-1638954191370 h1,.bt-1638954191370 h2,.bt-1638954191370 h3,.bt-1638954191370 h4,.bt-1638954191370 h5,.bt-1638954191370 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 > .block-content{ 
	/*
	* This feature only support developer.
	* Use !important for overwrite css.
	* For example:
	* font-size: 15px !important;
	* text-align: center !important;
	* ...
	*/
}
      }
      @media screen and (min-width: 960px){
        .bt-1614928661519{ height:773px;width:420px;max-width: 420px!important;position:relative!important;background-image: -webkit-linear-gradient( rgba(0,0,0,0), rgba(0,0,0,0)), url("https://static.botbanhang.vn/appon/e681f4b3-1328-4d85-af73-bc59017df571-1778715325402.png");background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1614928661519 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:773px;overflow: hidden; }.bt-1614928661519 p,.bt-1614928661519 h1,.bt-1614928661519 h2,.bt-1614928661519 h3,.bt-1614928661519 h4,.bt-1614928661519 h5,.bt-1614928661519 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592{ width:300px;left:50px;height:300px;top:172px;transform: translate(9.1px, 86.6px); }.bt-1614928709592 > .block-content{ background-color:transparent;background:transparent;font-family:Cabin;border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 p,.bt-1614928709592 h1,.bt-1614928709592 h2,.bt-1614928709592 h3,.bt-1614928709592 h4,.bt-1614928709592 h5,.bt-1614928709592 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1614928709592 > .block-content{ 
	overflow: hidden;
}.bt-1614928876606{ width:182px;left:120px;height:46px;top:574px; }.bt-1614928876606 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/aa8552cd-af6f-4ffe-b69c-94a242a1b13a-1778405985177.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Francois One;border-radius:20px 20px 20px 20px;border-width:0px;border-top-width:undefined;border-left-width:undefined;border-right-width:undefined;border-bottom-width:undefined;border-color:#000000;border-style:solid;color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1614928876606 p,.bt-1614928876606 h1,.bt-1614928876606 h2,.bt-1614928876606 h3,.bt-1614928876606 h4,.bt-1614928876606 h5,.bt-1614928876606 h6{ color: #FFEB3B!important;font-size:18px;color: #FFEB3B; }.bt-1615685249442{ height:774px;width:420px;max-width: 420px!important;position:relative!important;background-image: url('https://static.botbanhang.vn/appon/0c43d484-a6e7-407a-b447-9a2c8cf4f5b6-1778746641055.png');background-color: rgba(0,0,0,0);background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat; }.bt-1615685249442 > .block-content{ border-radius:0px 0px 0px 0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:774px;overflow: hidden; }.bt-1615685249442 p,.bt-1615685249442 h1,.bt-1615685249442 h2,.bt-1615685249442 h3,.bt-1615685249442 h4,.bt-1615685249442 h5,.bt-1615685249442 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1620980294208{ width:250px;left:95px;height:533px;top:198px;transform: translate(-9.7px, -14px); }.bt-1620980294208 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Oswald;text-align:justify;border-radius:0px 0px 0px 0px;color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1620980294208 p,.bt-1620980294208 h1,.bt-1620980294208 h2,.bt-1620980294208 h3,.bt-1620980294208 h4,.bt-1620980294208 h5,.bt-1620980294208 h6{ color: #009688;color: #009688!important;font-size:20px;color: #009688; }.bt-1638954191370{ width:23px;left:195px;height:30px;top:262px;transform: translate(3.8px, 2px); }.bt-1638954191370 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 p,.bt-1638954191370 h1,.bt-1638954191370 h2,.bt-1638954191370 h3,.bt-1638954191370 h4,.bt-1638954191370 h5,.bt-1638954191370 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638954191370 > .block-content{ 
	/*
	* This feature only support developer.
	* Use !important for overwrite css.
	* For example:
	* font-size: 15px !important;
	* text-align: center !important;
	* ...
	*/
}
        .desktop-app{
          float: unset!important;
          height: 780px!important;
          overflow: hidden!important;
          margin: 0px auto!important;
          padding-top: 60px!important;
          background-size: 100%!important;
          background-repeat: no-repeat;
        }
      }
      @media (min-width: 960px){
        #urlQrcode{
          display:block;
        }
      }
      .page-popup .wapper{
        border-radius: 10px 10px 0 0;
      }
      .dragg-sheet{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: .5rem;
        padding-bottom: 1rem;
        cursor: pointer;
      }
      .dragg-sheet span{
          display: block;
          height: 2px;
          width: 28px;
          margin-bottom: 2px;
          background-color: rgba(0,0,0,.3);
          border-radius: 2px;
      }
      @media screen and (max-width: 768px){
        #urlQrcode{
          display: none;
        }
      }
      @media screen and (min-width: 320px){
        #urlQrcode{
          z-index: 9999999999999;
          background: white;
        }
        #urlQrcode .center-div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    </style><script type="module" id="js-component-app">import thongtinkhachhang from "./thongtinkhachhang.vue";import camon from "./camon.vue";import thongbao from "./thongbao.vue";import phanqua from "./phanqua.vue";import quaquay from "./quaquay.vue";import quadanhan from "./quadanhan.vue";import share from "./share.vue";import themluot from "./themluot.vue";import matluot from "./matluot.vue";import chiase from "./chiase.vue";import loading from "./loading.vue";export default {components: {thongtinkhachhang,camon,thongbao,phanqua,quaquay,quadanhan,share,themluot,matluot,chiase,loading,},
            data: function () {
                return {
                    timeupdate: new Date().getTime(),
                    dataModelBU: [{name: "", data: []}],
                    actionClick: false,
                    urlQrcode: "https://app.appon.vn/6a16d652e81b18848682267f",
                    runslide: false,
                    touch_start: {x:0, y:0, move: false},
                    touch_move: {x: 0, y: 0},
                    item_start:{x:0},
                    showWatermark: "false",
                    testabc: "",
                    uidUser: "",
                    clickbt: 0,
                    page: 'home',
                    idapp: "6a16d652e81b18848682267f",mid:"",timestamp: new Date().getTime(),}
            },
            methods: {
                atou: function(str) {
                    return decodeURIComponent(escape(window.atob(str)));
                },
                runAction: function(val, cb) {
                  console.log("action start: ", val);
                  if (!val) {
                    return;
                  }
                  val.config = val.data;
                  var this_vue = this;
                  var timeout = val.time_out || 0;
                  switch (val.type) {
                    case "validate": 
                    setTimeout(function() {
                      try {
                        var status = this_vue.actionValidate(val.config);
                        if (!status) {
                          return false;
                        }
                        cb(null, val.config);
                      } catch (e) {
                        cb(e);
                      }
                    }, timeout);
                    break;
                    case "link":
                      setTimeout(function() {
                        try {
                          this_vue.actionLink(val.config, val.params);
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "page":
                      setTimeout(function() {
                        try {
                          this_vue.actionPage(val.config);
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "phone":
                      setTimeout(function() {
                        try {
                          this_vue.actionPhone(val.config);
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "email":
                      setTimeout(function() {
                        try {
                          this_vue.actionEmail(val.config);
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "position":
                        try {
                          setTimeout(function() {
                            this_vue.actionPosition(val.config);
                          }, timeout);
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      break;
                    case "model":
                      setTimeout(function() {
                        try {
                          this_vue.actionModel(
                            val.config.type,
                            val.config.key,
                            val.config.value_set_model,
                            val.config.type_set_value,
                            val.config.dataAppSelect
                          );
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "api":
                      try {
                        var dataHeader = {};
                        var data = {};
                        var dataParams = {};
                        var dataGet = "";
                        var arrBody = val.config.api_select.configs.body.valueNormal || [];
                        var arrParams = val.config.api_select.configs.params || [];
                        var arrHeader = val.config.api_select.configs.header || [];
                        var url = val.config.api_select.configs.url;
                        var urlCurent = this_vue.resetString(url);
                        var method = val.config.method;
                        var id = val.config.api_select.id;
                        var is_form = true;
                        var typeBd = val.config.api_select.configs.body.type;
                        var typeSend = "application/json";
                        if (arrBody && arrBody.length > 0) {
                          for(var i = 0; i < arrBody.length; i++) {
                            if (arrBody[i].key && arrBody[i].key.length > 0) {
                              if (arrBody[i].dataAppSelect && arrBody[i].dataAppSelect.useValue === "model") {
                                data[arrBody[i].key] = this_vue.getDataModelValue(arrBody[i].dataAppSelect);
                              } else {
                                data[arrBody[i].key] = this_vue.resetString(arrBody[i].value);
                              }
                            }
                          }
                        }
                        if (typeBd == "raw" && val.config.api_select.configs.body.valueRaw && val.config.api_select.configs.body.valueRaw.length > 0) { 
                          var dataraw = this_vue.resetString(val.config.api_select.configs.body.valueRaw);
                          dataraw = dataraw.replace("$model./g", "this_vue.");
                          var dataeval = "data = " + dataraw;
                          eval(dataeval);
                        }
                        for(var j = 0; j < arrParams.length; j++) {
                          if (arrParams[j].key && arrParams[j].key.length > 0) {
                            if (arrParams[j].key && arrParams[j].key.length > 0) {
                              var valueKey;
                              if (arrParams[j].dataAppSelect && arrParams[j].dataAppSelect.useValue === "model") {
                                valueKey = this_vue.getDataModelValue(arrParams[j].dataAppSelect);
                              } else {
                                valueKey = this_vue.resetString(arrParams[j].value);
                              }
                              dataParams[arrParams[j].key] = valueKey;
                              if (dataGet && dataGet.length > 0) {
                                dataGet += "&" + arrParams[j].key+"=" + valueKey;
                              } else {
                                dataGet += "?" + arrParams[j].key+"=" + valueKey;
                              }
                            }
                          }
                        }
                        for(var k = 0; k < arrHeader.length; k++) {
                          if (arrHeader[k].key && arrHeader[k].key.length > 0) {
                            if (arrHeader[k].dataAppSelect && arrHeader[k].dataAppSelect.useValue === "model") {
                              dataHeader[arrHeader[k].key] = this_vue.getDataModelValue(arrHeader[k].dataAppSelect);
                            } else {
                              dataHeader[arrHeader[k].key] = this_vue.resetString(arrHeader[k].value);
                            }
                          }
                        }
                        dataHeader['Content-Type'] = "application/json";
                        if (val.config.api_select.configs.body.type === "raw") {
                          is_form = false;
                          data = JSON.stringify(data);
                          //dataHeader['Content-Type'] = "raw";
                          typeSend = "raw";
                        }
                        if (val.config.security === "security") {
                          url = "https://security.appon.vn/v1/public/bu_send";
                          dataHeader.xapi = id;
                          dataHeader.xurl = urlCurent;
                        } else {
                          url = this_vue.resetString(url);
                        }
                        if (dataGet && dataGet.length > 0 && val.config.security != "security") {
                          url += dataGet;
                          urlCurent += dataGet;
                        }
                        if (val.config.security === "security") {
                          var time = new Date().getTime();
                          var dataHeaderSave = {
                            header: JSON.stringify(dataHeader),
                            body: JSON.stringify(data),
                            params: JSON.stringify(dataParams),
                            time: time,
                            typeSen: typeSend,
                            is_form: is_form,
                            url: urlCurent,
                            method: val.config.method,
                            mbot5: MD5(time + "" + JSON.stringify(dataHeader))
                          };
                          data = window.btoa(encodeURIComponent(JSON.stringify(dataHeaderSave)));
                          var part = data.slice(10, 23);
                          var string = '';
                          for(let i = 0; i < data.length; i++) {
                            string+= data[i];
                            if (i === 15 || i === data.length - 15) {
                              string+=part;
                            }
                          }
                          data = JSON.stringify({data: string});
                          method = "POST";
                          dataHeader = {"Content-Type": "application/json"};
                          dataParams = "";
                        } 
                        if (arrHeader && arrHeader.length > 0 && arrHeader[0] && arrHeader[0].key && arrHeader[0].key.length > 0) {
                          $.ajax({
                            method: ""+method,
                            url: url,
                            headers: dataHeader,
                            "data": data
                          }).done(function(res) {
                            if (val.config.actionSuccess && val.config.actionSuccess.length > 0) {
                              var dataSuc = val.config.actionSuccess;
                              dataSuc.find(function(x) {
                                x.res = res;
                              });
                              for (var i = 0; i < dataSuc.length; i++) {
                                this_vue.functionSuccess(dataSuc[i], function(res, abc){});
                                if (i == dataSuc.length - 1) {
                                  cb(null, res);
                                } 
                              }
                            } else {
                              cb(null, res);
                            }
                          }).fail(function(err) {
                            if (val.config.actionError && val.config.actionError.length > 0) {
                              var dataSuc = val.config.actionError;
                              dataSuc.find(function(x) {
                                x.err = err;
                              });
                              async.eachSeries(dataSuc, this_vue.functionError, function(err, result) {
                                cb(null,err);
                              });
                            }
                            setTimeout(function() {
                              cb(null,err);
                            },1000);
                          })
                        } else {
                          $.ajax({
                            method: method,
                            url: url,
                            "data": data
                          }).done(function(res) {
                            if (val.config.actionSuccess && val.config.actionSuccess.length > 0) {
                              var dataSuc = val.config.actionSuccess;
                              dataSuc.find(function(x) {
                                x.res = res;
                              });
                              for (var i = 0; i < dataSuc.length; i++) {
                                this_vue.functionSuccess(dataSuc[i], function(res, abc){});
                                if (i == dataSuc.length - 1) {
                                  cb(null, res);
                                } 
                              }
                            } else {
                              cb(null, res);
                            }
                          }).fail(function(err) {
                            if (val.config.actionError && val.config.actionError.length > 0) {
                              var dataSuc = val.config.actionError;
                              dataSuc.find(function(x) {
                                x.err = err;
                              });
                              async.eachSeries(dataSuc, this_vue.functionError, function(err, result) {
                                cb(null,err);
                              });
                            }
                            setTimeout(function() {
                              cb(null,err);
                            },1000);
                          })
                        }
                        
                      } catch (e) {
                        cb(e);
                      }
                      break;
                    case "function":
                      setTimeout(function() {
                        try {
                          var func = "" + val.config + "()";
                          eval(func);
                          cb(null, true)
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "tracking":
                      setTimeout(function() {
                        try {
                          var func = "" + val.config + "()";
                          eval(func);
                          cb(null, true)
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                    case "googleform":
                      try {
                        var data = {};
                        data.fvv = val.config.fvv;
                        data.draftResponse = val.config.draftResponse;
                        data.pageHistory = val.config.pageHistory;
                        data.fbzx = val.config.fbzx;
                        if (val.config.params && val.config.params.length > 0) {
                          for (var i = 0; i < val.config.params.length; i++) {
                            if (val.config.requireParams) {
                              if (this_vue[val.config.params[i].model] && this_vue[val.config.params[i].model].length > 0) {
                              }else {
                                var mess = val.config.messager_require || "Please check value!";
                                alert(mess);
                                return false;
                              }
                            }
                            if (val.config.params[i].key === "timestamp") {
                              data[val.config.params[i].key] = new Date().getTime();
                            } else {
                              if (val.config.params[i].dataAppSelect && val.config.params[i].dataAppSelect.useValue === "model") {
                                data[val.config.params[i].key] = this_vue.getDataModelValue(val.config.params[i].dataAppSelect);
                              } else {
                                data[val.config.params[i].key] =
                                this_vue[val.config.params[i].model];
                              }
                            }
                          }
                          $.ajax({
                            method: "POST",
                            url: "" + val.config.formResponse,
                            data: data
                          });
                        }
                        cb(null, val.config);
                      } catch (e) {
                        cb(null, val.config);
                      }
                      break;
                  }
                },
                actionValidate: function(val){
                  if (val && val.length > 0) {
                    for(var i = 0; i < val.length; i++) {
                      var mess = val[i].mess || "please check value!";
                      if (val[i].dataAppSelect && val[i].dataAppSelect.useValue === "model") {
                        var value = this.getDataModelValue(val[i].dataAppSelect);
                        if (val[i].type === "empty" && (!value || $.trim(value).length <= 0)) {
                          alert(mess);
                          return false;
                        }
                        var syntax = new RegExp(val[i].syntax);
                          if (val[i].type === "syntax" && !syntax.test(value)) {
                            alert(mess);
                            return false;
                          }
                      } else {
                        var key = val[i].model;
                        if (key && key.length > 0) {
                          var value = this[key];
                          if (val[i].type === "empty" && !this[key]) {
                            alert(mess);
                            return false;
                          }
                          var syntax = new RegExp(val[i].syntax);
                          if (val[i].type === "syntax" && !syntax.test(this[key])) {
                            alert(mess);
                            return false;
                          }
                        }
                      }
                    }
                  }
                  return true;
                },
                functionSuccess: function(val, cb) {
                  var this_vue = this;
                  switch (val.type) {
                      case "link":
                          try {
                            this_vue.actionLink(val.value_action);
                            cb(null, val.value_action);
                          } catch (e) {
                            cb(e);
                          }
                          break;
                      case "page":
                          try {
                            this_vue.actionPage(val.value_action);
                            cb(null, val.value_action);
                          } catch (e) {
                            cb(e);
                          }
                          break;
                      case "phone":
                          try {
                            this_vue.actionPhone(val.value_action);
                            cb(null, val.value_action);
                          } catch (e) {
                            cb(e);
                          }
                          break;
                      case "email":
                          try {
                            this_vue.actionEmail(val.value_action);
                            cb(null, val.value_action);
                          } catch (e) {
                            cb(e);
                          }
                          break;
                      case "position":
                          try {
                            this_vue.actionPosition(val.value_action);
                            cb(null, val.value_action);
                          } catch (e) {
                            cb(e);
                          }
                          break;
                      case "model":
                        try{
                          var value = "";
                          if (val.value_action.trim().search("res") == 0) {
                            var str = "value = val." + val.value_action + ";";
                            eval(str);
                          } else {
                              value = val.value_action;
                          }
                          this_vue.actionModel("", val.value_type, value, val.type_set_value, val.dataAppSelect);
                          cb(null, val.value_action);
                        }catch (e) {
                          cb(e);
                        }
                        
                      break;
                      case "tracking":
                          try {
                            var func = "" + val.value_action + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                      break;
                      case "function":
                          try {
                            var func = "" + val.value_action + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                      break;
                    }
                },
                functionError: function(val, cb) {
                  var this_vue = this;
                  switch (val.type) {
                      case "link":
                          this_vue.actionLink(val.value_action);
                          cb(null, val.value_action);
                          break;
                      case "page":
                          this_vue.actionPage(val.value_action);
                          cb(null, val.value_action);
                          break;
                      case "phone":
                          this_vue.actionPhone(val.value_action);
                          cb(null, val.value_action);
                          break;
                      case "email":
                          this_vue.actionEmail(val.value_action);
                          cb(null, val.value_action);
                          break;
                      case "position":
                          this_vue.actionPosition(val.value_action);
                          cb(null, val.value_action);
                          break;
                      case "model":
                        try{
                          var value = "";
                          value = val;
                          if (val.value_type && val.value_action && val.value_action.trim().search("err.") != -1) {
                            var str = "value = val." + val.value_action;
                            eval(str);
                          } else {
                              value = val.value_action;
                          }
                          this_vue.actionModel("", val.value_type, value, val.type_set_value, val.dataAppSelect);
                          cb(null, val.value_action);
                        }catch (e) {
                            cb(e);
                        }
                          break;
                      case "tracking":
                          try {
                            var func = "" + val.value_action + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                      break;
                      case "function":
                          try {
                            var func = "" + val.value_action + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                      break;
                    }
                },
                actionLink: function(link, params) {
                  var datalink = link;
                  if (params && params.length > 0) {
                    for(var i = 0; i < params.length; i++) {
                      if (i == 0) {
                        datalink += "?" + params[i].key + "=" + this.getDataModelValue(params[i].dataAppSelect);
                      } else {
                        datalink += "&" + params[i].key + "=" + this.getDataModelValue(params[i].dataAppSelect);
                      }
                    }
                  }
                  var linkaction = this.resetString(datalink);
                  var action = document.createElement("a");
                  action.setAttribute("href", linkaction);
                  action.setAttribute("target", "_blank");
                  action.click();
                  action.remove();
                },
                actionEmail: function(email) {
                  var action = "mailto:" + this.resetString(email);
                  var email = document.createElement("a");
                  email.setAttribute("href", action);
                  email.setAttribute("target", "_top");
                  email.click();
                  email.remove();
                },
                actionPhone: function(phone) {
                  var action = "tel:" + this.resetString(phone);
                  var phone = document.createElement("a");
                  phone.setAttribute("href", action);
                  phone.click();
                   phone.remove();
                },
                actionPosition: function(position) {
                  var wg = $("." + position);
                  var scTop = $(".wapper").scrollTop();
                  if (wg.attr("bt-type") == "blockLightBox") {
                    wg.css({"display":"flex"});
                  } else {
                    var top = wg.offset().top + scTop;
                    $(".wapper").animate({
                      scrollTop: top
                    },500);
                  }
                },
                setValueDataList: function(value, dataAppSelect) {
                },
                actionModel: function(type, key, value, type_set_value, dataAppSelect) {
                  var val = "";
                  var valuesetModel;
                  if (typeof value === "string") {
                    val = value.trim();
                  }
                  if (val && val != "" && val.length > 4 && val.search("{{") >= 0) {
                    valuesetModel = this.resetString(val);
                  } else {
                    if (type === "number") {
                      valuesetModel = parseFloat(value);
                    } else {
                      valuesetModel = value;
                    }
                  }
                  var thisVue = this;
                  valuesetModel = thisVue.resetString(valuesetModel);
                  switch(type_set_value) {
                    case "length":
                      if (dataAppSelect && dataAppSelect.useValue === "model") {
                        thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel.length);
                      } else {
                        thisVue[key] = valuesetModel.length;
                      }
                      break;
                    case "assign":
                      if (dataAppSelect && dataAppSelect.useValue == "model") {
                        thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                      }else {
                        thisVue[key] = valuesetModel;
                      }
                      break;
                    case "concat":
                        if (Array.isArray(valuesetModel) && valuesetModel.length > 0) {
                          try {
                            for(var i = 0; i < valuesetModel.length; i++) {
                              if (dataAppSelect && dataAppSelect.useValue === "model") {
                                thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                              }else {
                                thisVue[key].push(valuesetModel[i]);
                              }                              
                            }
                          } catch(e) {
                          }
                        } else {
                          if (dataAppSelect && dataAppSelect.useValue === "model") {
                            thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                          }else {
                            thisVue[key].push(valuesetModel);
                          }                          
                        }
                      break;
                    default:
                      if (dataAppSelect && dataAppSelect.useValue === "model") {
                        thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                      } else {
                        thisVue[key] = valuesetModel;
                      }
                      break;
                  }
                  // var data = JSON.parse(this.budcodedata(localStorage.getItem("botup-model")));
                  // data["dataModelBU"] = $.extend(true, [], this.dataModelBU);
                  // localStorage.setItem("botup-model", this.buecodedata(JSON.stringify(data)));
                },
                actionPage: function(page) {
                  var thisVue = this;
                  if(page == 'home') {
                    if (this.page == "home") {} else {
                    $model = this;
                    var data = localStorage.getItem("botup-model"); 
                     data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                     thisVue.dataModelBU = $.extend(true, [], data.dataModelBU);
                    thisVue.mid = data.mid;
                    thisVue.timeupdate = new Date().getTime();
                     var pageAc = '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';
                                                pageAc = JSON.parse(thisVue.atou(pageAc));
                                                async.eachSeries(pageAc, thisVue.runAction, function(err, result) {
                                                   
                                                      });}
                  } else {
                    if (this.page == 'home') {
                      var data = {mid:this.mid,timestamp:this.timestamp,};
                    data["dataModelBU"] = $.extend(true, [], this.dataModelBU);
                    data.bu_appID = '6a16d652e81b18848682267f';
                    localStorage.setItem("botup-model", this.buecodedata(JSON.stringify(data)));
                    }
                  }
                  this.page = page;
                },
                dbclickfn: function(event) {
                  event.stopPropagation();
                  event.preventDefault();
                  return false;
                },
                click: function (event, val) {
                  //event.stopPropagation();
                  //event.preventDefault();
                  var thisVue = this;
                  if (thisVue.atou(val) && thisVue.atou(val) != undefined && thisVue.atou(val) != "undefined") {
                    var val = JSON.parse(thisVue.atou(val));      
                    if (thisVue.clickbt == 0) {
                      thisVue.clickbt = 1;
                      async.eachSeries(val, thisVue.runAction, function(err, result) {
                        thisVue.clickbt = 0;
                      });
                      thisVue.clickbt = 0;
                    }
                  }
                },
                sliderLeftimg: function(event, id) {
                  var wgSlider = $("."+id);
                  var col = wgSlider.find(".list-img").attr("data-col");
                  var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                  var listItem = wgSlider.find(".list-img img");
                  listItem.removeClass("bounceInLeft").addClass("bounceInRight").hide();
                  listItem.each(function() {
                    if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                      $(this).show();
                    }
                  })
                  indexSl = indexSl + parseFloat(col);
                  if (indexSl >= listItem.length) {
                    indexSl = 0;
                  }
                  wgSlider.find(".img-show").attr({
                    "data-sl": indexSl,
                    "src": listItem.eq(indexSl).attr("src")
                  });
                },
                sliderRightimg: function(event, id) {
                  var wgSlider = $("."+id);
                  var col = wgSlider.find(".list-img").attr("data-col");
                  var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                  var listItem = wgSlider.find(".list-img img");
                  listItem.removeClass("bounceInRight").addClass("bounceInLeft").hide();
                  listItem.each(function() {
                    if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                      $(this).show();
                    }
                  })
                  indexSl = indexSl + parseFloat(col);
                  if (indexSl >= listItem.length) {
                    indexSl = 0;
                  }
                  wgSlider.find(".img-show").attr({
                    "data-sl": indexSl,
                    "src": listItem.eq(indexSl).attr("src")
                  });

                },
                runSliderimg: function() {
                  var wgSlide = $('.block-widget[bt-type="blockSlider"]');
                  var thisVue = this;
                  if (wgSlide && wgSlide.length > 0) {
                    wgSlide.each(function() {
                      thisVue.runItemSliderImg($(this));
                    });
                  }
                },
                runItemSliderImg: function(wgSlider) {
                  var thisVue = this;
                  var col = wgSlider.find(".list-img").attr("data-col");
                  var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                  var listItem = wgSlider.find(".list-img img");
                  // click item img
                  if (listItem && listItem.length > 0) {
                    listItem.css({"width": (100/parseFloat(col))+"%"}).hide();
                    listItem.each(function() {
                      if (parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                        $(this).show();
                      }
                    });
                    indexSl = indexSl + parseFloat(col);
                    wgSlider.find(".img-show").attr({
                      "data-sl": indexSl,
                      "src": listItem.eq(indexSl).attr("src")
                    });

                    listItem.off("click").on("click", function() {
                      var $this = $(this);
                      listItem.removeClass("active");
                      $this.addClass("active");
                      wgSlider.find(".img-show").attr({
                        "data-sl": $this.attr("data-show"),
                        "src": $this.attr("src")
                      });
                    });

                    thisVue.setInterValSlider(wgSlider, col, listItem, indexSl);
                    wgSlider.off("mouseenter").on("mouseenter", function() {
                      clearInterval(thisVue[""+wgSlider.attr("data-id")]);
                    });
                    wgSlider.off("mouseleave").on("mouseleave", function() {
                      listItem.removeClass("bounceInLeft").addClass("bounceInRight");
                      thisVue.setInterValSlider(wgSlider, col, listItem, indexSl);
                    })
                  }
                },
                setInterValSlider: function(wgSlider, col, listItem, indexSl) {
                  var thisVue = this;
                  thisVue[""+wgSlider.attr("data-id")] = setInterval(function() {
                    var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                    if (parseFloat(indexSl) < listItem.length) {
                      listItem.removeClass("active").hide();
                      listItem.eq(indexSl).addClass("active");
                      var total = parseFloat(col) + indexSl;
                      listItem.each(function() {
                        if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                          $(this).show();
                        }
                      })
                      indexSl = indexSl + parseFloat(col);
                      if (indexSl >= listItem.length) {
                        indexSl = 0;
                      }
                      wgSlider.find(".img-show").attr({
                        "data-sl": indexSl,
                        "src": listItem.eq(indexSl).attr("src")
                      });
                    } else {
                      indexSl = 0;
                      wgSlider.find(".img-show").attr({
                        "data-sl": indexSl,
                        "src": listItem.eq(indexSl).attr("src")
                      });
                      listItem.removeClass("active").hide();
                      listItem.eq(indexSl).addClass("active");
                      listItem.each(function() {
                        if (indexSl <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                          $(this).show();
                        }
                      })
                    }
                  }, 5000);
                },
                sliderLeft: function(event, id) {
                  var thisVue = this;
                  if (!this.runslide) {
                    this.runslide = true;
                    var itemFirst = $("."+id+" > .block-content").eq(0);
                    var listitem = $("."+id+" > .block-content");
                    var left = parseFloat(itemFirst.css("margin-left"));
                    var index = Math.round(left / itemFirst.outerWidth());
                    if (index < 0) {
                      var marginLeft = (index + 1) * itemFirst.outerWidth();
                      itemFirst.animate({
                        "margin-left": marginLeft + "px"
                      }, 300);
                      setTimeout(function() {
                        thisVue.runslide = false;
                      });
                    } else {
                      thisVue.runslide = false;
                    }
                  }
                },
                sliderRight: function(event, id) {
                  var thisVue = this;
                  if (!this.runslide) {
                    this.runslide = true;
                    var itemFirst = $("."+id+" > .block-content").eq(0);
                    var listitem = $("."+id+" > .block-content");
                    var left = parseFloat(itemFirst.css("margin-left"));
                    var index = Math.round(left / itemFirst.outerWidth());
                    if (0 - index < listitem.length - 1) {
                      var marginLeft = (index - 1) * itemFirst.outerWidth();
                      itemFirst.animate({
                        "margin-left": marginLeft + "px"
                      }, 300);
                      setTimeout(function() {
                        thisVue.runslide = false;
                      });
                    } else {
                      thisVue.runslide = false;
                    }
                  }
                },
                touchstart: function(event, id) {
                  var touch = event.touches[0];
                  this.touch_start.x = touch.pageX;
                  this.touch_start.y = touch.pageY;
                  var itemFirst = $("."+id+" > .block-content").eq(0);
                  this.item_start.x = parseFloat(itemFirst.css("margin-left"));
                },
                touchmove: function(event, id) {
                  this.touch_start.move = "true";
                  var touch = event.touches[0];
                  this.touch_move.x = touch.pageX;
                  this.touch_move.y = touch.pageY;
                  var itemFirst = $("."+id+" > .block-content").eq(0);
                  var marg = this.touch_move.x - this.touch_start.x + this.item_start.x;
                  itemFirst.css({
                    "margin-left": marg + "px"
                  });
                },
                touchend: function(event, id) {
                  var touch = event.touches[0];
                  var width = $("."+id).eq(0).outerWidth();
                  if (this.touch_start.move === "true") {
                    var itemFirst = $("."+id+" > .block-content").eq(0);
                    var marg = parseFloat(itemFirst.css("margin-left"));
                    if(marg > 0) {marg = 0};
                    itemFirst.css({
                      "margin-left": marg + "px"
                    });

                    var numItem = $("."+id+" > .block-content").length;
                    if((width - marg - numItem * parseFloat(itemFirst.outerWidth())) > 10) {
                      marg = width - numItem * parseFloat(itemFirst.outerWidth());
                      itemFirst.css({
                        "margin-left": marg + "px"
                      });
                    }
                    this.touch_start.move = false;
                  }
                },
                blurInput: function(event, require, mess) {
                  var error = mess || "Please check value!";
                  var value = $(event.target).val();
                  var type = $(event.target).attr("type");
                  var pattern = $(event.target).attr("pattern");
                  if (require && (!pattern || pattern.length <= 0)) {
                    switch(type) {
                      case "text":
                        if (!value || value.length === 0) {
                          alert(error);
                        }
                      break;
                      case "email":
                        if (value && value.length > 0 && value.search("@") > 0 && value.search("@") != (value.length -1)) {

                        } else {
                          alert(error);
                          // event.target.setCustomValidity(error);
                        }
                      break;
                      case "phone":
                        if(value && value.length > 0) {

                        } else {
                          alert(error);
                          //event.target.setCustomValidity(error);
                        }
                      break;
                      case "number":
                        if (parseFloat(value)) {

                        } else {
                          alert(error);
                          //event.target.setCustomValidity(error);
                        }
                      break;
                      default:
                          if (!value || value.length === 0) {
                            alert(error);
                            //event.target.setCustomValidity(error);
                          }
                        break;
                    }
                  } else {
                    if (pattern && pattern.length > 0 && require) {
                      var reg = new RegExp(pattern);
                      if (!reg.test(value)) {
                        alert(error);
                      }
                    }
                  }
                },
                resetString: function(str){
                  if (typeof str == 'string' && str.search("{{") >= 0) {
                    var arr = str.split("{{");
                    var arrMo = [];
                    for(var i = 0; i< arr.length; i++) {
                      if(arr[i].search("}}") != -1) {
                        arrMo.push(arr[i].split("}}")[0]);
                      }
                    }
                    for(var j = 0; j < arrMo.length; j++) {
                      var val = arrMo[j];

                      if (val.search(".") != 0 && val.search(".") != -1) {
                        var child = val.split(".");
                        var values = this[child[0]];
                        for (var n = 1; n < child.length; n++) {
                          values = values[child[n]];
                          if (n === (child.length -1) && typeof values === "object") {
                            var stringconvert = JSON.stringify(values);
                            str = str.replace("{{" + arrMo[j] + "}}", stringconvert);
                          }
                        }
                        str = str.replace("{{" + arrMo[j] + "}}", values);
                      } else {
                        if (typeof this[val] === "object") {
                          var stringconvert = JSON.stringify(this[val]);
                          str = str.replace("{{" + arrMo[j] + "}}", stringconvert);
                        } else {
                          var valeval = eval("this."+val);
                          if(typeof valeval == "object") {
                            str = valeval;
                          } else{
                            str = str.replace("{{" + arrMo[j] + "}}", eval("this."+val));
                          }
                        }
                      }
                      if(typeof str != "object") { 
                        str = str.replace("[[", "[");
                        str = str.replace("]]", "]");
                      }
                    }
                    return str;
                  } else {
                    return str;
                  }
                },
                resetSticky: function(wg) {
                    if (wg && wg.length > 0) {
                      if ($("body").outerWidth() > 768) {
                        var left = parseFloat(wg.css("left"));
                        var leftBody = $(".bt-component").offset().left;
                        var top = parseFloat(wg.css("top")) + $(".bt-component").offset().top;
                        var bottom = $(".bt-component").offset().top + $(".bt-component").outerHeight();
                        var heightWindow = $(window).outerHeight();
                        if (wg.hasClass("top")) {
                          if (wg.attr("bt-type") === "blockColumnOnly" || wg.attr("bt-type") === "blockList") {
                            wg.css({"top": top + "px", "left": "unset"});
                          } else {
                            wg.css({"left": (left + leftBody) + "px", "top": top + "px"});
                          }
                        } else {
                          if (bottom > heightWindow) {
                            top = "unset";
                          } else {
                            top = (bottom - parseFloat(wg.css("bottom")) - parseFloat(wg.css("height"))) + "px";
                          }
                          if (wg.attr("bt-type") === "blockColumnOnly" || wg.attr("bt-type") === "blockList") {
                            wg.css({"top": top, "left": "unset"});
                          } else {
                            wg.css({"left": (left + leftBody) + "px", "top": top});
                          }
                        }
                      } else {
                          if(!wg.hasClass("top")) {
                            wg.css({"top":"unset"});
                          }
                      }
                      wg.removeClass("sticky-bt");
                    } 
                },
                checkActiveApp: function() {
                  var thisVue = this;
                  $.ajax({
                    url: "https://check.appon.vn/v1/public/check_upgrade_app?id=" + thisVue.idapp+"&v=4&ip="+thisVue.uidUser,
                    method: "GET",
                    success: function(data) {
                      thisVue.uidUser = data.data.uid;
                      localStorage.setItem("ipA", data.data.uid);
                      if (data && data.data && data.data.status) {
                        $("#bu-watermark").hide();
                      } else {
                        $("#bu-watermark").show();
                      }
                    }, error: function(data) {
                      $("#bu-watermark").show();
                    }
                  });
                },
                custom_method: function(val) {
                  var fun = val + "();";
                  eval(fun);
                },
                getDataModelValue: function(dataSL) {
                  var value;
                  value = this.gm(dataSL.nameTab, dataSL.keySelect, dataSL.indexKey);
                  return value;
                },
                getDataModelBu: function(next) {
                  var thisVue = this;
                    $.ajax({
                      url: "https://api.appon.vn/v1/public/data-app_read_public",
                      method: "POST",
                      data: {page_use: '6a16d652e81b18848682267f'},
                      success: function(dataRes) {
                        try {
                          var data = localStorage.getItem("botup-model"); 
                          if (data && data.search("bu_appID") == -1) {
                            data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                            if (data.bu_appID != '6a16d652e81b18848682267f') {
                              thisVue.dataModelBU = $.extend(true, [], dataRes.data[0].data.data);
                              thisVue.timeupdate = new Date().getTime();
                              data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                              data.bu_appID = '6a16d652e81b18848682267f';
                              localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                            }else {
                              if (data["dataModelBU"]) {

                                thisVue.dataModelBU = $.extend(true, dataRes.data[0].data.data, data["dataModelBU"]);
                                data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                                localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                              } else {
                                thisVue.dataModelBU = dataRes.data[0].data.data;
                                thisVue.timeupdate = new Date().getTime();
                                data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                                localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                              }
                            }
                          } else {
                            data = {};
                            data.bu_appID = '6a16d652e81b18848682267f';
                            if (dataRes.data.length > 0) {
                              thisVue.dataModelBU = $.extend(true, [], dataRes.data[0].data.data);
                            } else {
                              thisVue.dataModelBU = [];
                            }
                            thisVue.timeupdate = new Date().getTime();
                            data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                            localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                          }
                          next();
                        } catch (err) {
                          console.log("err:: ", err);
                          localStorage.removeItem("botup-model");
                          //window.location.reload();
                          next();
                        }
                      },
                      error: function(err) {
                        console.log("err:: ", err);
                        localStorage.removeItem("botup-model");
                        //window.location.reload();
                        next();
                      }
                    });
                },
                buecodedata: function(data) {
                  var string = '';
                  try {
                    var codedata = window.btoa(unescape(encodeURIComponent(data)));
                    var part = codedata.slice(10, 18);
                    for(let i = 0; i < codedata.length; i++) {
                      string+= codedata[i];
                      if (i === 13 || i === codedata.length - 13) {
                        string+=part;
                      }
                    }
                  } catch(e) {
                    
                  }
                  return string;
                },
                budcodedata: function(data) {
                  var codedata = "";
                  try{
                    codedata = data.slice(0, 14) + data.slice(22, data.length - 20) + data.slice(data.length - 12, data.length);
                    codedata = decodeURIComponent(escape(window.atob(codedata)));
                  } catch(e) {

                  }
                  return codedata;
                },
                getDataModel: function(nametab, namekey, indexkey) {
                  return this.gm(nametab, namekey, indexkey);
                },
                gm: function(nametab, namekey, indexkey) {
                  var value = "";
                  if (!namekey && !indexkey && !nametab) {
                    return value;
                  }
                  if (nametab && !namekey && !indexkey) {
                    value = this.dataModelBU.find(e => e.name == nametab);
                    return value.data;
                  }
                  if (nametab && namekey && !indexkey && (indexkey != 0 || indexkey != '0')) {
                    value = [];
                    var data = this.dataModelBU.find(e => e.name == nametab);
                    for (var i = 0; i < data.data.length; i++) {
                      value.push(data.data[i][namekey]);
                    }
                    return value;
                  }
                  var data = this.dataModelBU.find(e => e.name == nametab);
                  if (data.data[indexkey]) {
                    value = data.data[indexkey][namekey];
                  }
                  return value;
                  
                },
                setDataModel: function(nametab, namekey, indexkey, value) {
                  this.sm(nametab, namekey, indexkey, value);
                },
                sm: function(nametab, namekey, indexkey, value) {
                  var thisVue = this;
                  try{
                    if (typeof indexkey == "string") {
                      indexkey.trim();
                    }
                    if ((indexkey && indexkey.length > 0) || (namekey && indexkey === 0)) {
                      indexkey = parseFloat(indexkey);
                      thisVue.dataModelBU.find(function(e) {
                        if (e.name == nametab) {
                          e.data[indexkey][namekey] = value;
                        }
                      });
                    } else {
                      if (nametab && namekey) {
                        if (Array.isArray(value)) {
                          var dataTab = thisVue.dataModelBU.find((e) => e.name == nametab);
                          var leng = value.length;
                          if (value.length < dataTab.data.length) {
                            leng = dataTab.data.length;
                          }
                          for(var i = 0; i < leng; i++) {
                            if (dataTab.data[i]) {
                              dataTab.data[i][namekey] = value[i] || "";
                            } else {
                              var arrkey = Object.keys(dataTab.data[i-1]);
                              var item = {};
                              for( var j = 0; j < arrkey.length; j++) {
                                if (arrkey[j] == namekey) {
                                  eval("item."+arrkey[j]+" = value[i]");
                                  item[arrkey[j]] = value[i];
                                } else {
                                  eval("item."+arrkey[j]+" = ''");
                                }
                              }
                              dataTab.data[i] = item;
                            }
                          }
                          thisVue.dataModelBU.find(function(e) {
                            if (e.name === nametab) {
                              if (dataTab && dataTab.data) {
                                e.data = $.extend(true, [], dataTab.data);
                              } else {
                                e.data = $.extend(true, [], dataTab.data);
                              }
                            }
                          });
                        } else {
                          thisVue.dataModelBU.find(function(e) {
                            if (e.name == nametab) {
                              if (e.data[0]) {
                                for(var i = 0; i < e.data.length; i++) {
                                  e.data[i][namekey] = null;
                                }
                              } else {
                                eval("e.data[0] = {"+namekey+": value};");
                              }
                            }
                          });
                        }
                      } else {
                        if (nametab) {
                          thisVue.dataModelBU.find(function(e) {
                            if (e.name == nametab) {
                              if (Array.isArray(value)) {
                                e.data = $.extend(true, [], value);
                              } else {
                                e.data = [];
                                e.data[0] = value;
                              }
                            }
                          });
                        }
                      }
                    }
                    
                    var data = localStorage.getItem("botup-model");
                    if (data) {
                      data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                    } else {
                      data = {};
                    }
                    data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                    localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                    thisVue.timeupdate = new Date().getTime();
                  } catch(e) {
                    console.log(e);
                  };
                },
                checkradioChangeValue: function(event, val) {
                  var thisVue = this;
                  var modelSet;
                  var value = $(event.target).attr("data-value");
                  var elemTarget = $(event.target).parent().find("input");
                  var name = elemTarget.attr("data-name") + "radio";
                  if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                    modelSet = JSON.parse(this.atou(val));
                  }
                  if (!value) {
                    value = $(event.target).parent().find("input").val();
                    elemTarget = $(event.target).parent().find("input");
                  }
                  thisVue[name] = value;
                  if (modelSet) {
                    this.sm(modelSet.nameTab, modelSet.keySelect, modelSet.indexKey, thisVue[name]);
                  }
                },
                checkboxChangeValue: function(event, val) {
                  event.preventDefault();
                  var thisVue = this;
                  var elemTarget = $(event.target).parent().find("input");
                  var name = elemTarget.attr("data-name") + "checkbox";
                  var value = elemTarget.attr("data-value");
                  var modelSet;
                  if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                    modelSet = JSON.parse(this.atou(val));
                  }
                  if (modelSet) {
                    var index = thisVue[name].indexOf(value);
                    if (index >= 0) {
                      elemTarget.removeClass("checked");
                      thisVue[name].splice(index,1);
                    } else {
                      elemTarget.addClass("checked");
                      thisVue[name].push(value);
                    }
                    this.sm(modelSet.nameTab, modelSet.keySelect, modelSet.indexKey, thisVue[name]);
                  }
                },
                responsive: function() {
                  var wScreen = $("html").outerWidth();
                  var wgVP = $("#bt-viewport");
                  var zoom = 1;
                  var content = "";
                  if (wgVP.attr("content").search('initial-scale="1"') != -1 || wgVP.attr("content").search('initial-scale=1,') != -1 || wgVP.attr("content").search('width=device-width,initial-scale=1') != -1) {
                    if (wScreen < 767) {
                      zoom = wScreen/420;
                      content = "width=420px, initial-scale="+zoom+", maximum-scale="+zoom+", minimum-scale="+zoom+",user-scalable=0,minimal-ui,user-scalable=no";
                    } else {
                      if (wScreen < 960) {
                        zoom = wScreen/768;
                        content = "width=768px, initial-scale="+zoom+", maximum-scale="+zoom+", minimum-scale="+zoom+",user-scalable=0,minimal-ui,user-scalable=no";
                      } else {
                        zoom = wScreen/1280;
                        content = "width=960px, initial-scale="+zoom+", maximum-scale="+zoom+", minimum-scale="+zoom+",user-scalable=0,minimal-ui,user-scalable=no";
                      }
                    }
                    wgVP.attr("content", content);
                  }
                },
                changeValueSelectOption: function(event,val) {
                  var thisVue = this;
                  if (thisVue.atou(val) && thisVue.atou(val) != undefined && thisVue.atou(val) != "undefined") {
                    var value = JSON.parse(thisVue.atou(val));
                    if ($(event.target).attr("id")) {
                      var id =  $(event.target).attr("id").replace("select-bt-", "");
                      thisVue.sm(value.nameTab, value.keySelect, value.indexKey, thisVue["modelsl"+id]);
                    }
                  }
                },
                addModelDefault: function() {
                  this.createDataCheckbox();
                  this.createDataSelectBox();
                },
                closeLBox: function(ev, id) {
                  ev.stopPropagation();
                  ev.preventDefault();
                  if ($(ev.target).hasClass("block-lightbox") || $(ev.target).hasClass("close-light-box")) {
                    $("."+id).hide();
                  }
                },
                createDataCheckbox: function() {
                  var thisVue = this;
                  var wgCheck = $('.block-widget[bt-type="blockCheckbox"] > input');
                  if (wgCheck && wgCheck.length > 0) {
                    wgCheck.each(function() {
                      var name = $(this).attr("data-name") + 'checkbox';
                      if(!thisVue[name]) {
                        thisVue[name] = [];
                      }
                    })
                  }
                  var wgRadio = $('.block-widget[bt-type="blockRadio"] > input');
                  if (wgRadio && wgRadio.length > 0) {
                    wgRadio.each(function() {
                      var nameR = $(this).attr("data-name") + 'radio';
                      if(!thisVue[nameR]) {
                        thisVue[nameR] = "";
                      }
                    })
                  }
                },
                createDataSelectBox: function() {
                  var wgSl = $('.block-widget[bt-type="blockSelect"]');
                  var thisVue = this;
                  if (wgSl && wgSl.length > 0) {
                    wgSl.each(function() {
                      if ($(this).attr("data-id")) {
                        var id = $(this).attr("data-id").replace("bt-", "");
                        var value = $(this).find(".value-default-sl").attr("value");
                        var valuesm = $(this).attr("data-sm");
                        if (thisVue.atou(valuesm) && thisVue.atou(valuesm) != undefined && thisVue.atou(valuesm) != "undefined") {
                          valuesm = JSON.parse(thisVue.atou(valuesm));
                          thisVue.sm(valuesm.nameTab, valuesm.keySelect, valuesm.indexKey, value);
                        }
                        thisVue["modelsl"+id] = value;
                        $(this).find("select").val(value);
                      }
                    });
                  }
                },
                runCountdown: function(id, data, action) {
                  var thisVue = this;
                  var dataCount = JSON.parse(this.atou(data));
                  var dataAction = false;
                  if (this.atou(action) && this.atou(action) != undefined && this.atou(action) != "undefined") {
                    dataAction = JSON.parse(this.atou(action));
                  }
                    var dataDate;
                    var dateToday = new Date().getTime();
                    if (dataCount && dataCount.typeTime && dataCount.typeTime == 1) {
                      var dateend = new Date(dataCount.timeEnd).getTime();
                      dataDate = Math.floor((dateend - dateToday)/1000);
                    } else {
                      dataDate = Math.floor(parseFloat(dataCount.timeDay))*(24*60*60) + parseFloat(dataCount.timeHour)*(60*60) + parseFloat(dataCount.timeMin)*60 + parseFloat(dataCount.timeSec);
                    }
                    var dataValue = {
                      day: 0,
                      hour: 0,
                      min: 0,
                      sec: 0
                    };
                  var runC = setInterval(function() {
                    if (dataDate > 0) {
                      dataValue.day = Math.floor(dataDate/(24*60*60));
                      dataValue.hour = Math.floor(dataDate/(60*60)) - dataValue.day*24;
                      dataValue.min = Math.floor(dataDate/60) - dataValue.day*(24*60) - dataValue.hour*60;
                      dataValue.sec = dataDate%60;
                      if (dataValue.day < 10) {
                        dataValue.day = "0"+dataValue.day;
                      }
                      if (dataValue.hour < 10) {
                        dataValue.hour = "0"+dataValue.hour;
                      }
                      if (dataValue.min < 10) {
                        dataValue.min = "0"+dataValue.min;
                      }
                      if (dataValue.sec < 10) {
                        dataValue.sec = "0"+dataValue.sec;
                      }
                      dataDate--;
                    } else {
                      dataValue = {day: "00",hour: "00",min: "00",sec: "00"};
                      clearInterval(runC);
                      if (dataAction) {
                        async.eachSeries(dataAction, thisVue.runAction, function(err, result) {
                        });
                      }
                    }
                    $("."+id+" .item-count.count-day .value-count").text(dataValue.day);
                    $("."+id+" .item-count.count-hour .value-count").text(dataValue.hour);
                    $("."+id+" .item-count.count-min .value-count").text(dataValue.min);
                    $("."+id+" .item-count.count-sec .value-count").text(dataValue.sec);

                  }, 1000);
                  
                },
                checkCountdown: function() {
                  var thisVue = this;
                  var wg = $(".app-on-home .block-widget.block-countdown");
                  if (wg && wg.length > 0) {
                    wg.each(function() {
                      var id = $(this).attr("data-id");
                      var dataTime = $(this).find(".block-content").attr("data-time");
                      var dataAction = $(this).find(".block-content").attr("data-action");
                      thisVue.runCountdown(id, dataTime, dataAction);
                    })
                  }
                },
                formatCurency: function(val) {
                  var dataFormat = "";
                  if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                    dataFormat = JSON.parse(this.atou(val));
                    var value = this.gm(dataFormat.nametab, dataFormat.namekey, dataFormat.indexkey)
                    if (typeof value == "number") {
                      var formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        minimumFractionDigits: 0,
                        currency: dataFormat.typeCurency
                      });
                      this.sm(dataFormat.nametab, dataFormat.namekey, dataFormat.indexkey, formatter.format(value));
                    }
                  }
                }
            },
            created: function() {
              
            },
            mounted: function () {
              $model = this;
              var thisVue = this;
              this.responsive();
              thisVue.uidUser = localStorage.getItem("ipA");
              this.getDataModelBu(function() {
                $("#app").addClass("desktop-app");
                  if ($("html").outerWidth() > 768 && $("html").outerWidth() < 960) {
                    //$("#app").addClass("tablet");
                  } else {
                    if ($("html").outerWidth() >= 960) {
                      //$("#app").addClass("desktop-app");
                    }
                  }
                  $("#bu-watermark").css({"top": "unset", "bottom": "0", "left": "0px", "height":"30px"});
                  $("#bu-watermark img").unbind("click").click(function() {
                    $("#bu-watermark a").show();
                  });
                  thisVue.checkActiveApp();
                  var wow = new WOW(
                    {
                      boxClass: 'wow',
                      animateClass: 'animated',
                      offset: 0, 
                      mobile: true,
                      live: true
                    }
                  );
                  wow.init();
                  var url = window.location.href;
                  thisVue.urlQrcode = url;
                var botupModel = thisVue.budcodedata(localStorage.getItem("botup-model"));
                if (botupModel && botupModel.length > 0) {
                  botupModel = JSON.parse(botupModel);
                  if ((url.search("https://app.appon.vn") != -1 && url.search(botupModel.bu_appID) === -1) || (url.search("https://app.appon.vn") != -1 && url.search(botupModel.bu_appID) === -1)) {
                            localStorage.removeItem("botup-model");
                          } else {
                            thisVue.mid = botupModel.mid;
                          }
                }
                setTimeout(function() {
                  thisVue.checkCountdown();
                  thisVue.addModelDefault();
                  var wgSticky = $(".sticky-bt");
                  if (wgSticky && wgSticky.length > 0) {
                    wgSticky.each(function() {
                      if ($(this).hasClass("top") || $(this).hasClass("bottom")) {
                        thisVue.resetSticky($(this));
                      } else {
                        $(this).removeClass("sticky-bt").removeClass("none");
                      }
                    })
                  }
                  thisVue.runSliderimg();
                  
                }, 300);
                
                  var botup_model = localStorage.getItem("botup-model");
                  if (botup_model) {
                    botup_model = thisVue.budcodedata(localStorage.getItem("botup-model"));
                    botup_model = JSON.parse(botup_model);
                    thisVue.mid = botup_model.mid;thisVue.timestamp = new Date().getTime();
                  } else {
                      var data = {
                        bu_appID: "6a16d652e81b18848682267f",mid:"",timestamp: new Date().getTime(),
                      };
                      data.dataModelBU = $.extend(true, [],botup_model.dataModelBU);
                      localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                      
                        window.extAsyncInit = function() {
                          window.MessengerExtensions.getContext('2279252778962648',
                          function success(thread_context){
                            var model_botup = thisVue.budcodedata(localStorage.getItem("botup-model"));
                            if (thread_context.psid && thread_context.psid.length > 0) {
                              if (!model_botup) {
                                model_botup = {};
                                model_botup.mid = thread_context.psid;
                                thisVue.mid = thread_context.psid;
                                localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(model_botup)));
                              } else {
                                model_botup = JSON.parse(model_botup);
                                model_botup.mid = thread_context.psid;
                                thisVue.mid = thread_context.psid;
                                localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(model_botup)));
                              }
                            }
                             var pageAc = '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';
                                pageAc = JSON.parse(thisVue.atou(pageAc));
                                async.eachSeries(pageAc, thisVue.runAction, function(err, result) {
                                      });
                          },
                          function error(err){
                             var pageAc = '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';
                                pageAc = JSON.parse(thisVue.atou(pageAc));
                                async.eachSeries(pageAc, thisVue.runAction, function(err, result) {
                                      });
                          });
                        };}
      try{
        window.extAsyncInit();
      } catch(e){
         var pageAc = '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';
                                    pageAc = JSON.parse(thisVue.atou(pageAc));
                                    async.eachSeries(pageAc, thisVue.runAction, function(err, result) {
                                          });console.log("e:: ", e);
      }
      var url_string = window.location.href;
      var url = new URL(url_string);
      var mid = url.searchParams.get("mid");
      var model_botup = thisVue.budcodedata(localStorage.getItem("botup-model"));
      if (mid && mid.length > 0) {
        if (!model_botup) {
          model_botup = {};
          model_botup.mid = mid;
          thisVue.mid = mid;
          localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(model_botup)));
        } else {
          model_botup = JSON.parse(model_botup);
          model_botup.mid = mid;
          thisVue.mid = mid;
          localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(model_botup)));
        }
      }
              });
              // end mounted
              var name = this.$router.history.current.name;
              this.page = name;
            }

        }</script>